import * as React from "react";
import IconButton from "@mui/material/IconButton";
import { Menu } from "@material-ui/core";
import { FaEllipsisV } from "react-icons/fa";
import { forwardRef, useImperativeHandle } from "react";

const CommonMenu2 = forwardRef(
  ({ menuContent, rowData, data, isIntercutPage }, ref) => {
    const [anchorE2, setAnchorE2] = React.useState(null);
    const open = Boolean(anchorE2);
    const handleClick = (event) => {
      event.stopPropagation();
      setAnchorE2(event.currentTarget);
    };

    useImperativeHandle(ref, () => ({
      handleClose() {
        setAnchorE2(null);
      },
    }));
    return (
      <div>
        <div
          className={`menu-icon-button ${
            data
              ? data.id === rowData.id
                ? "hovered"
                : ""
              : "" || open
              ? "hovered"
              : ""
          }`}
        >
          <IconButton
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            className="menu-icon-button"
          >
            <FaEllipsisV className="fs-20" />
          </IconButton>
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorE2}
          open={open}
          onClose={() => ref.current.handleClose()}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          disableScrollLock={true}
          className={`${isIntercutPage ? "mg-top-60" : "margin-top-85"}`}
        >
          <div className="mg-top-10 action-menu-container">
            {menuContent.map((item, index) => (
              <div
                className={`manage-section-dropdown-item cp`}
                onClick={(event) => {
                  event.stopPropagation();
                  item.ApiCall(rowData);
                }}
              >
                {item.icon}
                <div className="manage-section-dropdown-item-link">
                  <p className="manage-small-popup-menuu1-p">{item.name}</p>
                </div>
              </div>
            ))}
          </div>
        </Menu>
      </div>
    );
  }
);

export default CommonMenu2;
